import React, { useState, useEffect } from 'react';
import { Card, Form, Button, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import GLOBALVAR from '../../constants';

const TestTemplate = ({ showNotification }) => {
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [testData, setTestData] = useState({});
    const [recipient, setRecipient] = useState('');

    useEffect(() => {
        const fetchTemplates = async () => {
            try {
                const response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/templates`);
                setTemplates(response.data);
            } catch (error) {
                showNotification('Failed to fetch templates', 'danger');
            }
        };

        fetchTemplates();
    }, [showNotification]);

    const handleTemplateChange = async (templateId) => {
        try {
            const response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/templates/${templateId}`);
            setSelectedTemplate(response.data);
            // Extract variables from template body
            const variables = {};
            const matches = response.data.body.match(/{{([^}]+)}}/g) || [];
            matches.forEach(match => {
                const key = match.replace(/[{}]/g, '');
                variables[key] = '';
            });
            setTestData(variables);
        } catch (error) {
            showNotification('Failed to fetch template details', 'danger');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await axios.post(`${GLOBALVAR['SERVER_ROOT']}/api/templates/${selectedTemplate.id}/test`, {
                testData,
                recipient
            });
            showNotification('Test message sent successfully');
        } catch (error) {
            showNotification(error.response?.data?.message || 'Failed to send test message', 'danger');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card>
            <Card.Body>
                <Card.Title>Test Template</Card.Title>
                <Form onSubmit={handleSubmit}>
                    <Row className="g-3">
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label>Select Template</Form.Label>
                                <Form.Select
                                    onChange={(e) => handleTemplateChange(e.target.value)}
                                    disabled={loading}
                                >
                                    <option value="">Choose a template...</option>
                                    {templates.map(template => (
                                        <option key={template.id} value={template.id}>
                                            {template.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        {selectedTemplate && (
                            <>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label>
                                            {selectedTemplate.type === 'email' ? 'Email' : 'Phone Number'}
                                        </Form.Label>
                                        <Form.Control
                                            type={selectedTemplate.type === 'email' ? 'email' : 'text'}
                                            value={recipient}
                                            onChange={(e) => setRecipient(e.target.value)}
                                            placeholder={selectedTemplate.type === 'email' ? 
                                                'Enter email address' : 'Enter phone number'
                                            }
                                            disabled={loading}
                                        />
                                    </Form.Group>
                                </Col>

                                {Object.keys(testData).map(key => (
                                    <Col md={6} key={key}>
                                        <Form.Group>
                                            <Form.Label>{key}</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={testData[key]}
                                                onChange={(e) => setTestData({
                                                    ...testData,
                                                    [key]: e.target.value
                                                })}
                                                disabled={loading}
                                            />
                                        </Form.Group>
                                    </Col>
                                ))}

                                <Col md={12}>
                                    <div className="d-flex justify-content-end">
                                        <Button 
                                            type="submit"
                                            disabled={loading || !recipient}
                                        >
                                            {loading ? 'Sending...' : 'Send Test'}
                                        </Button>
                                    </div>
                                </Col>
                            </>
                        )}
                    </Row>
                </Form>
            </Card.Body>
        </Card>
    );
};

export default TestTemplate;